// Imports
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/base/Index.vue"),
      children: [
        {
          path: "/",
          name: "Home",
          component: () => import("@/views/home/Home.vue")
        },
        {
          path: "/sign-up",
          component: () => import("@/views/home/SignUp.vue")
        },
        {
          path: "/feature",
          component: () => import("@/views/home/Feature.vue")
        },
        {
          path: "/logistics",
          component: () => import("@/views/home/Logistics.vue")
        },
        {
          path: "/payment",
          component: () => import("@/views/home/Payment.vue")
        },
        {
          path: "/pricing",
          component: () => import("@/views/home/Pricing.vue")
        },
        {
          path: "/cases",
          component: () => import("@/views/home/Cases.vue")
        },
        {
          path: "/about-us",
          component: () => import("@/views/home/AboutUs.vue")
        },
        {
          path: "/register-agreement",
          component: () => import("@/views/home/RegisterAgreement.vue")
        },
      
        {
          path: "/success",
          component: () => import("@/views/home/Success.vue")
        },
        {
          path: "/activation",
          component: () => import("@/views/home/activation.vue")
        },
        {
          path: "/question",
          component: () => import("@/views/home/question.vue")
        },

        {
          path: "/template-index",
          component: () => import("@/views/template/index.vue")
        },
        {
          path: "/template-list",
          component: () => import("@/views/template/list.vue")
        },
        {
          path: "/template-detail",
          component: () => import("@/views/template/detail.vue")
        },
        {
          path: "/user-index",
          component: () => import("@/views/template/user_index.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/balance",
          component: () => import("@/views/template/balance.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/buyed",
          component: () => import("@/views/template/buyed.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/income",
          component: () => import("@/views/template/income.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/withdrawal",
          component: () => import("@/views/template/withdrawal.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/consume",
          component: () => import("@/views/template/consume.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/template-detail-custom",
          component: () => import("@/views/template/detail_custom.vue"),
          meta: {
            needLogin: true
          }
        },
        {
          path: "/privacy-policy",
          component: () => import("@/views/article/PrivacyPolicy.vue")
        },
        {
          path: "/consumer-agreement",
          component: () => import("@/views/article/ConsumerAgreement.vue")
        },
        {
          path: "/terms-service",
          component: () => import("@/views/article/TermsService.vue")
        },
        {
          path: "/user-agreement",
          component: () => import("@/views/article/UserAgreement.vue")
        },

      ]
    },
    {
      path: "/sign-in",
      component: () => import("@/views/SignIn.vue")
    },
  ]
});
router.beforeEach(function(to, from, next) {
  if (to.meta.needLogin) {
    if (localStorage.getItem("DROPSHOPUSERINFO")) {
      next();
    } else {
      next({ name: "Home" });
    }
  } else {
    next();
  }
});

// ==================== SEO 配置 ====================
const SEO = {
  '/': {
    'zh-CN': { title: 'Taoify - 跨境电商独立站建站平台 | 零代码开店，全球收付款', desc: 'Taoify提供零代码跨境电商独立站建站服务，10分钟搭建品牌官网，集成PayPal/Stripe/支付宝等100+支付渠道，覆盖200+国家物流，助力中国卖家轻松出海。' },
    'en': { title: 'Taoify - Cross-Border E-Commerce Platform | Zero-Code Store Setup', desc: 'Taoify offers zero-code cross-border e-commerce store building. Set up your branded store in 10 minutes with integrated global payments, logistics, and multi-language support.' },
  },
  '/feature': {
    'zh-CN': { title: '80+功能模块 - Taoify 跨境电商功能', desc: 'Taoify提供80+跨境电商功能模块，从建站、铺货、收款、物流到营销推广和数据分析，一站式覆盖外贸独立站所有需求。' },
    'en': { title: '80+ Features - Taoify Cross-Border E-Commerce Features', desc: 'Taoify provides 80+ cross-border e-commerce features covering store building, product listing, payments, logistics, marketing, and data analytics.' },
  },
  '/logistics': {
    'zh-CN': { title: '跨境物流 · 智能履约 - Taoify 全球物流网络', desc: 'Taoify整合国际专线、海外仓与多仓智能调度，覆盖200+国家，提供实时追踪与透明费率，助力DTC品牌高效履约。' },
    'en': { title: 'Smart Fulfillment - Taoify Global Logistics Network', desc: 'Taoify integrates international shipping lines, overseas warehouses, and multi-warehouse smart dispatch covering 200+ countries with real-time tracking.' },
  },
  '/payment': {
    'zh-CN': { title: '全球收款 · 极速安全 - Taoify 一站式支付解决方案', desc: '集成PayPal、Stripe、支付宝、微信支付等100+支付渠道，多币种智能结算，资金直达账户，零隐形费用。' },
    'en': { title: 'Global Payments - Taoify All-in-One Payment Solution', desc: 'Integrate 100+ payment methods including PayPal, Stripe, Alipay, and WeChat Pay with multi-currency settlement and zero hidden fees.' },
  },
  '/pricing': {
    'zh-CN': { title: '独立站全功能免费开放 - Taoify 价格', desc: 'Taoify 0元建站，0交易佣金，无限商品，无限流量。推广期注册永久享受免费权益。' },
    'en': { title: 'All Features Free - Taoify Pricing', desc: 'Taoify offers free store building with zero commission, unlimited products, and unlimited traffic. Register now for permanent free benefits.' },
  },
  '/cases': {
    'zh-CN': { title: '成功案例 - Taoify 品牌出海案例', desc: '50,000+跨境卖家信赖的独立站平台，来自不同行业的真实成功故事，看他们如何用Taoify抢占全球市场。' },
    'en': { title: 'Success Stories - Taoify Brand Globalization Cases', desc: '50,000+ sellers trust Taoify. Real success stories from various industries showing how to win global markets with Taoify.' },
  },
  '/sign-up': {
    'zh-CN': { title: '店铺开通 - Taoify 免费注册开店', desc: '10分钟搭建品牌独立站，零代码、零佣金、全链路闭环。立即免费注册Taoify，开启跨境电商之旅。' },
    'en': { title: 'Sign Up - Taoify Free Store Registration', desc: 'Build your branded store in 10 minutes. Zero code, zero commission, full-chain closed loop. Register now and start your cross-border journey.' },
  },
  '/template-index': {
    'zh-CN': { title: '模版市场 - Taoify 专业网站主题模板', desc: '适用于任何项目的专业主题网站模板，海量行业模板免费使用，根据需求自定义品牌形象和功能。' },
    'en': { title: 'Theme Marketplace - Taoify Professional Website Templates', desc: 'Professional theme templates for any project. Free industry templates with customizable branding and features.' },
  },
  '/question': {
    'zh-CN': { title: '帮助中心 - Taoify 跨境电商使用指南', desc: 'Taoify帮助中心提供开店教程、支付配置、物流设置、营销推广等全方位跨境电商使用指南和常见问题解答。' },
    'en': { title: 'Help Center - Taoify Cross-Border E-Commerce Guides', desc: 'Taoify Help Center provides comprehensive guides on store setup, payment configuration, logistics, marketing, and FAQs.' },
  },
};

function updatePageSEO(path, locale) {
  const seoData = SEO[path];
  if (!seoData) return;
  const data = seoData[locale] || seoData['en'];
  document.title = data.title;

  const metaDesc = document.querySelector("meta[name='description']");
  if (metaDesc) metaDesc.setAttribute('content', data.desc);

  document.documentElement.lang = locale === 'zh-CN' ? 'zh-CN' : 'en';
}

// Route change SEO update
router.afterEach((to) => {
  const locale = localStorage.getItem('langdef') || 'zh-CN';
  updatePageSEO(to.path, locale);
});

// Init SEO on first load
const initLocale = localStorage.getItem('langdef') || 'zh-CN';
updatePageSEO(window.location.pathname, initLocale);

export default router;
